import { AnhangDtoModel } from './AnhangDtoModel';
import { AntragsType } from '../types';
import { TokenState } from './TokenState';

export class AntragDtoModel {
  public angelegt!: string;
  public antragsArt!: AntragsType;
  public antragsseiteInfo!: AnhangDtoModel[];
  public anzBelege!: number;
  public anzSeiten!: number;
  public concurrency!: string;
  public containerId!: string;
  public containerName!: string;
  public eingereicht!: string | null;
  public flags?: AntragsFlag[];
  public hochgeladen!: string;
  public id!: string;
  public origin!: number;
  public removalDate!: Date;
  public seitenBytesTotal!: number;
  public status!: number;
  public token!: string;
  public tokenState!: TokenState;
  public uebergeben!: string | null;
  public metadata: string | undefined | null;

  public get isFeatureDedicatedBelegEnabledOnAntrag(): boolean {
    return this.flags?.some((flag) => flag === 'HasDedicatedFirst') ?? false;
  }

  public get isLangantrag(): boolean {
    return this.antragsArt === AntragsType.LANGANTRAG_LEGACY || this.antragsArt === AntragsType.LANGANTRAG;
  }
}

export type AntragsFlag = 'HasDedicatedFirst';

export interface AntragsInfoExtended extends AntragDtoModel {
  antragsSize: string;
  belege: AnhangDtoModel[][];
  canDeleteAntrag: boolean;
  cannotDecrypt: boolean;
  hasDedicatedFirst: boolean;
  statusTypeCss: string;
  statusTypeIcon: string;
  title: string;
  titleDate: string;
  titleBelege: string;
  titleTotalA11y: string;
}
